import React, { useState, useRef, useMemo, useLayoutEffect, useCallback, useEffect } from 'react';
import './index.less';
import { Empty, Space } from 'antd';

const PageAdapter = (props) => {
  const { blockWidth = 151, blockHeight = 110, row = 1, space = [16, 16], current = '' } = props;

  const dataSummaryRef = useRef();
  // 监听window大小变化
  const [windowSize, setWindowSize] = useState({
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
  });

  // 防抖更新window大小信息
  const onResize = () => {
    setWindowSize({
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    });
  };

  // 订阅布局变化
  useLayoutEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  });

  // 当前面板所在页码
  const [currentPage, changePage] = useState(1);

  // 修改当前页码
  const onChangePage = useCallback(
    (operate) => {
      switch (operate) {
        case 'prev':
          changePage(currentPage - 1);
          break;
        default:
          changePage(currentPage + 1);
      }
    },
    [currentPage]
  );

  //格式化数据
  const handleSummaryGroup = (param) => {
    const { row, height, width, data } = param;
    // 每个指标模块的宽度 blockWidth
    // const blockWidth = 151;
    // 每个指标模块的高度 blockHeight
    // const blockHeight = 110;
    // 全部展开后需要的行数
    const autoRow = height ? Math.ceil(height / blockHeight) : 0;
    // 根据宽度自适应的列数
    const autoColumn = Math.floor((width + space[0]) / (blockWidth + space[0]));

    // 全部展开行数大于自定义行数时
    if (row && autoRow >= row) {
      // 每页可展示的模块个数
      const itemNum = row * autoColumn;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return arrTo2Dimension(data, itemNum);
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return [data];
    }
  };

  const datadiv = document.getElementById('data-container');

  //一维数组转二维
  const arrTo2Dimension = (arr, n) => {
    // 待转换数组长度
    const len = arr.length;
    // 转换目标数据长度
    const targetLen = len % n === 0 ? len / n : Math.floor(len / n + 1);

    const target = [];
    for (let i = 0; i < targetLen; i++) {
      const temp = arr.slice(i * n, i * n + n);
      target.push(temp);
    }

    return target;
  };
  const handleSummaryRef = useRef();
  handleSummaryRef.current = handleSummaryGroup;
  //使用document.clientWidth获取到的宽度是浏览器测量后的取整的数值，导致分页不准确，采取getBoundingClientRect()来获取
  const newData = useMemo(() => {
    // 注意：当window大小变化时，需要同步刷新data
    if (dataSummaryRef && dataSummaryRef.current && windowSize) {
      return handleSummaryRef.current({
        row,
        height: dataSummaryRef.current.getBoundingClientRect().height,
        width: dataSummaryRef.current.getBoundingClientRect().width,
        data: props.children,
      });
    }
    return [];
  }, [row, props.children, windowSize]);
  console.log(777, newData);

  useEffect(() => {
    if (!newData.length) return;
    newData.map((list, index) => {
      if (!list.length) return;
      if (!current) changePage(1);
      list.map((item) => {
        if (item.key == current) changePage(index + 1);
      });
    });
  }, [newData, current]);

  return (
    <div ref={dataSummaryRef} className="TY_page-adapter-data-summary-container" id="data-container">
      {newData.length > 0 ? (
        <>
          {/* 坐标回退按钮 */}
          <div
            className="TY_data-summary-container-arrow to-prev "
            onClick={onChangePage.bind(null, 'prev')}
            style={{
              visibility: currentPage === 1 || newData.length <= 1 ? 'hidden' : 'visible',
            }}
          >
            <div className="TY_data-summary-container-icon">
              <span className="TY_data-summary-container-icon-to-next"> &lt;</span>
            </div>
            {/* <LeftCircleOutlined style={{ width: '38px', height: '38px' }} /> */}
          </div>
          <div
            className="TY_data-summary-container-arrow to-next"
            style={{
              visibility: currentPage === newData.length || newData.length <= 1 ? 'hidden' : 'visible',
            }}
            onClick={onChangePage.bind(null, 'next')}
          >
            <div className="TY_data-summary-container-icon">
              <span className="TY_data-summary-container-icon-to-next"> &gt;</span>
            </div>
          </div>
          {/* 中间内容区域 */}
          <div
            className="TY_data-summary-container-content"
            style={{
              transform: `translateX(-${(currentPage - 1) * (dataSummaryRef?.current?.clientWidth || 0)}px)`,
            }}
          >
            {newData.length > 0 &&
              newData.map((summaryGroup, index) => {
                return (
                  <div key={`group_${index}`} className="TY_data-summary-container-page" style={{ width: '100%' }}>
                    <Space size={space} wrap={true}>
                      {summaryGroup.map((item, key) => {
                        const overlayContent = <div>{item.warning}</div>;

                        return <div key={key}>{item}</div>;
                      })}
                    </Space>
                  </div>
                );
              })}
          </div>
        </>
      ) : (
        <Empty />
      )}
    </div>
  );
};
export default PageAdapter;
